import { Spinner, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Billing/Billing.module.scss'
import BillingForm from 'modules/Forms/Billing/BillingForm'
import AdmitadWarning from 'modules/Billing/subcomponents/AdmitadWarning'
import Placeholder from 'modules/Billing/subcomponents/Placeholder'
import PaymentMethods from 'modules/Billing/subcomponents/PaymentMethods'
import { useBilling } from 'modules/Forms/Billing/useBilling'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import Billing from 'modules/Forms/Billing/hoc/Billing'
import { IS_APP_PRODUCT_GETUNIQ } from 'utils/constants/product'
import Notification from 'modules/Billing/subcomponents/Notification'
import { useHistory } from 'react-router'

const DepositReplenish = () => {
  const pathGen = useGeneratePathI18n()
  const history = useHistory()

  const {
    data: { methods: { loading, loaded, data: methods = [] } = {}, activeMethod } = {},
    setActiveMethod,
    getPaymentMethods,
    getAccountData,
    pushMethods,
  } = useBilling('billing')

  const { t } = useTranslation(['billing'])

  useEffect(() => {
    getPaymentMethods()
  }, [])

  useEffect(() => {
    if (activeMethod?.method === 'admitad') {
      getAccountData({ id: activeMethod.method })
    }
  }, [activeMethod])

  useEffect(
    () => loaded && IS_APP_PRODUCT_GETUNIQ && pushMethods([{ method: 'admitad' }]),
    [loaded],
  )

  return (
    <>
      <Helmet defer={false}>
        <title>{t('head.deposit.title')}</title>
      </Helmet>

      <Billing>
        {!loaded ? (
          <Placeholder />
        ) : (
          <>
            <div className={styles['billing__content-top']}>
              <Notification />

                    <Typography
                      variant={'Header-40'}
                      component={'h1'}
                      noMargin
                      className={'margin-bottom-32'}
                    >
                      {t('balance_replenishment')}
                    </Typography>

              {loading && (
                <div className={styles['billing__spinner']}>
                  <Spinner color="Label-GU-Primary" />
                </div>
              )}

              {loaded && (
                <PaymentMethods
                  className={'margin-bottom-40 '}
                  handleClickSlider={setActiveMethod}
                  data={methods.map(({ method, ...rest }) => ({
                    title: t(`methods.${method}`),
                    method,
                    active: activeMethod?.method === method,
                    ...rest,
                  }))}
                />
              )}

              {activeMethod?.method === 'admitad' ? (
                <AdmitadWarning />
              ) : (
                <BillingForm onClose={() => history.push(pathGen(ROUTES.FINANCE_WALLETS))} />
              )}
            </div>

            <div
              className={styles['billing__content-bottom']}
              dangerouslySetInnerHTML={{
                __html: t('info', {
                  link: pathGen(ROUTES.TICKET_NEW),
                }),
              }}
            />
          </>
        )}
      </Billing>
    </>
  )
}

DepositReplenish.propTypes = {
  onClose: PropTypes.func,
}
export default DepositReplenish
